import { WifiOff, Cloud, X, AlertCircle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { useOfflineQueue } from '@/hooks/useOfflineQueue';

export const OfflineIndicator = () => {
  const { isOnline, hasPendingUpdates, pendingUpdates, clearAllUpdates } = useOfflineQueue();

  // Check if updates are stale (older than 5 minutes - show warning faster)
  const hasStaleUpdates = pendingUpdates.some(u => 
    Date.now() - u.timestamp > 5 * 60 * 1000
  );

  if (isOnline && !hasPendingUpdates) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50 animate-fade-in">
      {!isOnline ? (
        <Badge 
          variant="destructive" 
          className="flex items-center gap-2 px-3 py-2 text-sm shadow-lg"
        >
          <WifiOff className="w-4 h-4" />
          Offline Mode
        </Badge>
      ) : hasPendingUpdates ? (
        <Badge 
          variant="secondary" 
          className={`flex items-center gap-2 px-3 py-2 text-sm shadow-lg ${
            hasStaleUpdates 
              ? 'bg-destructive/20 text-destructive-foreground border-destructive' 
              : 'bg-warning text-warning-foreground'
          }`}
        >
          {hasStaleUpdates ? (
            <AlertCircle className="w-4 h-4" />
          ) : (
            <Cloud className="w-4 h-4 animate-pulse" />
          )}
          {hasStaleUpdates 
            ? 'Sync stuck - tap X to clear' 
            : `Syncing ${pendingUpdates.length} update${pendingUpdates.length > 1 ? 's' : ''}...`
          }
          <button
            onClick={(e) => {
              e.stopPropagation();
              clearAllUpdates();
            }}
            className="ml-1 hover:bg-foreground/20 rounded p-0.5 transition-colors"
            aria-label="Clear pending updates"
          >
            <X className="w-3 h-3" />
          </button>
        </Badge>
      ) : null}
    </div>
  );
};
